import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-kostenstelle-list-view',
  imports: [],
  templateUrl: './kostenstelle.list-view.html',
  styleUrls: ['./kostenstelle.list-view.css'],
})
export class KostenstelleListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
